import {
  CompWithFormProp,
  FormConfigProps,
} from '../../../constants/constants';
import { DynamicFormField } from '../../DynamicFormField';

export const languageSubjectsConfig: Record<string, FormConfigProps> = {
  colorCoding: {
    label:
      'naudojamas spalvinis kodavimas, pažymint esminę informaciją, skirstant ją pagal svarbą',
    value: 'colorCoding',
  },
  listeningAndFollowing: {
    label: 'teksto klausymas derinamas su teksto sekimu',
    value: 'listeningAndFollowing',
  },
  createdPlan: {
    label:
      'kūrybiniai rašto darbai atliekami, remiantis paties mokinio sudarytu planu',
    value: 'createdPlan',
  },
  providedPlan: {
    label:
      'kūrybiniai rašto darbai atliekami, remiantis mokytojo sudarytu planu',
    value: 'providedPlan',
  },
  comprehensionQuestions: {
    label:
      'teksto analizės užduotyse tekstas skaidomas pastraipomis, po jomis / prieš jas pateikiant teksto suvokimo klausimus',
    value: 'comprehensionQuestions',
  },
  closedEndedQuestions: {
    label: 'teksto analizė atliekama atsakant į uždaro tipo testo klausimus',
    value: 'closedEndedQuestions',
  },
  openEndedQuestions: {
    label:
      'teksto analizė atliekama atsakant į uždaro ir atviro tipo testo klausimus',
    value: 'openEndedQuestions',
  },
  designatedGraphicOrganizer: {
    label: 'teksto  analizė atliekama pildant numatytą grafinę tvarkyklę',
    value: 'designatedGraphicOrganizer',
  },
};

export const SubjectLanguage = ({ form }: CompWithFormProp) => {
  return (
    <DynamicFormField
      formItemConfig={languageSubjectsConfig}
      formPathParams={['subject', 'block3', 'methods']}
      form={form}
    />
  );
};
